export type Shape = {
  width: number;
  height: number;
};
